module.exports = __webpack_public_path__ + "img/child1.41eb7ee3.png";